import React from 'react';
import { FaPhoneAlt, FaMapMarkerAlt, FaEnvelope } from 'react-icons/fa';
import { motion } from 'framer-motion';
import bg1 from '../assets/bg1.jpg';

const Contact = () => {
  const images = [bg1];
  const bgNum = Math.floor(Math.random() * 1);
  const bgImage = images[bgNum];

  return (
    <div className="text-center">
      <motion.div
        className="relative h-96 bg-cover bg-center"
        style={{ backgroundImage: `url(${bgImage})` }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center flex-col text-center">
          <h1 className="text-[#EFF8E2] text-4xl font-bold mb-4 mt-12">Contact Us</h1>
          <motion.div
            whileHover={{
              scale: 1.1,
              translateZ: 50,
              perspective: 1000,
              boxShadow: '0px 20px 30px rgba(0, 0, 0, 0.4)',
              transition: { duration: 0.2 },
            }}
            className="inline-block mb-4"
          >
            <a
              href="tel:+12067660409"
              className="bg-[#25292C] text-[#EFF8E2] px-4 py-2 rounded font-bold"
            >
              <span>📞</span>
              <span>(206) 766 0409</span>
            </a>
          </motion.div>
        </div>
      </motion.div>
      <div className="container mx-auto px-4 py-8">
        <h2 className="text-2xl font-bold mb-4">Contact Us</h2>
        <div className="flex flex-col items-center space-y-4 mb-8">
          <motion.div
            className="flex items-center space-x-2"
            whileHover={{ scale: 1.1, transition: { duration: 0.3 } }}
          >
            <FaPhoneAlt className="text-[#25292C]" style={{ verticalAlign: 'middle' }} />
            <a
              href="tel:+12067660409"
              className="bg-[#EFF8E2] text-[#25292C] px-4 py-2 rounded font-bold flex items-center space-x-2"
              style={{ perspective: '500px' }}
            >
              206-766-0409
            </a>
          </motion.div>
          <div className="flex items-center space-x-2">
            <FaMapMarkerAlt className="text-[#25292C]" style={{ verticalAlign: 'middle' }} />
            <p className="text-lg">1001 Central Ave N, Kent, WA 98032</p>
          </div>
          <motion.div
            className="flex items-center space-x-2"
            whileHover={{ scale: 1.1, transition: { duration: 0.3 } }}
          >
            <FaEnvelope className="text-[#25292C]" style={{ verticalAlign: 'middle' }} />
            <a
              href="mailto:emailhere"
              className="bg-[#EFF8E2] text-[#25292C] px-4 py-2 rounded font-bold flex items-center space-x-2"
              style={{ perspective: '500px' }}
            >
              emailhere
            </a>
          </motion.div>
        </div>
        <div className="flex flex-col items-center space-y-4 mb-0">
          <h2 className="text-2xl font-bold">Operating Hours</h2>
          <p className="text-lg">Monday-Saturday: 9 AM–6 PM</p>
          <p className="text-lg">Sunday: Closed</p>
        </div>
        <div className="flex justify-center mt-8">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d200.24759555649098!2d-122.23097603546182!3d47.39175920278826!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54905f092703b54f%3A0xea9b8fd5a47f26d7!2sNova%20Auto%20Detaling!5e1!3m2!1sen!2sus!4v1720544748313!5m2!1sen!2sus"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default Contact;
